import { useMutation } from '@apollo/client/react';
import { CombinedGraphQLErrors } from '@apollo/client';
import { REPLACE_IMAGE_FROM_LOAD, REMOVE_IMAGE_FROM_LOAD } from '../../../../graphql/client/mutations';
import { GET_LOAD_PROGRESS } from '../../../../graphql/client/queries';
import {
    ReplaceImageForALoadInputDetails,
    ReplaceImageForALoadInput,
    RemoveImageFromALoadInputDetails,
    RemoveImageFromALoadInput,
} from '../../../../types/schemaTypes';

const useRemoveReplaceImage = (name: string, loadId: number): any => {
    const [replaceImage, { loading: replaceMutationLoading }] = useMutation(REPLACE_IMAGE_FROM_LOAD, {
        onError: (e) => {
            if (CombinedGraphQLErrors.is(e)) {
                console.log('GraphQL Error', e.errors);
            } else {
                console.log('Error', e.message);
            }
        },
        refetchQueries: () => {
            return [
                {
                    query: GET_LOAD_PROGRESS,
                    variables: { loadId: loadId },
                },
            ];
        },
    });

    const [removeImage] = useMutation(REMOVE_IMAGE_FROM_LOAD, {
        onError: (e) => {
            if (CombinedGraphQLErrors.is(e)) {
                console.log('GraphQL Error', e.errors);
            } else {
                console.log('Error', e.message);
            }
        },
        refetchQueries: () => {
            return [
                {
                    query: GET_LOAD_PROGRESS,
                    variables: { loadId: loadId },
                },
            ];
        },
    });

    const handleAllChangesForReplaceImage = async (event: any, ticketName: string): Promise<any> => {
        const reader = new FileReader();
        const file = event.target.files[0];

        let extension = '';
        let imageData = '';
        reader.onloadend = async () => {
            extension = file.name.split('.').pop();
            imageData = reader.result ? reader.result.toString().replace(/^data:(.*,)?/, '') : '';
        };
        reader.readAsDataURL(file);
        //Since FileReader taking a while to fill extension and imageData have used setTimeout--the update to happen after 2 sec.
        setTimeout(() => {
            let imageName = '';
            if (ticketName === 'stn') {
                imageName = `Load-${loadId}-Stn2.${extension.toLowerCase()}`;
            }
            if (ticketName === 'bol') {
                imageName = `Load-${loadId}-Bol.${extension.toLowerCase()}`;
            }
            if (ticketName === 'bol2') {
                imageName = `Load-${loadId}-Other.${extension.toLowerCase()}`;
            }
            if (event) {
                event.preventDefault();
            }

            const replaceImageForALoadInputDetails: ReplaceImageForALoadInputDetails = {
                imageName: imageName,
                imageData: imageData,
                name: ticketName,
                isDriver: false,
            };

            const replaceImageForALoadInput: ReplaceImageForALoadInput = {
                loadId: loadId,
                replaceImageForALoad: replaceImageForALoadInputDetails,
            };
            replaceImage({
                variables: { input: replaceImageForALoadInput },
            });
        }, 200);
    };

    const handleAllChangesForRemoveImage = async (ticketName: string): Promise<any> => {
        const removeImageFromALoadInputDetails: RemoveImageFromALoadInputDetails = {
            imageName: ticketName,
        };

        const removeImageFromALoadInput: RemoveImageFromALoadInput = {
            loadId: loadId,
            removeImageFromLoad: removeImageFromALoadInputDetails,
        };
        removeImage({
            variables: { input: removeImageFromALoadInput },
        });
    };

    return {
        handleAllChangesForReplaceImage,
        handleAllChangesForRemoveImage,
        replaceMutationLoading,
    };
};

export default useRemoveReplaceImage;
